import { type ReactNode } from 'react';
import { cn } from '@/lib/utils';

type Tone = 'neutral' | 'success' | 'warning' | 'danger' | 'info';

const TONE: Record<Tone, string> = {
  neutral: 'bg-slate-100 text-slate-700',
  success: 'bg-emerald-100 text-emerald-700',
  warning: 'bg-amber-100 text-amber-700',
  danger: 'bg-red-100 text-red-700',
  info: 'bg-sky-100 text-sky-700',
};

export function Badge({
  children,
  tone = 'neutral',
  className,
}: {
  children: ReactNode;
  tone?: Tone;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium',
        TONE[tone],
        className
      )}
    >
      {children}
    </span>
  );
}

export function statusTone(
  status: string
): 'neutral' | 'success' | 'warning' | 'danger' | 'info' {
  switch (status) {
    case 'active':
    case 'authorized':
    case 'healthy':
    case 'success':
      return 'success';
    case 'awaiting_auth':
    case 'provisioning':
    case 'draining':
      return 'warning';
    case 'suspended':
    case 'unknown':
      return 'neutral';
    case 'error':
    case 'unhealthy':
    case 'expired':
    case 'decommissioned':
      return 'danger';
    case 'none':
    default:
      return 'neutral';
  }
}
